import { inject, Injectable } from '@angular/core';
import {
  WebsiteMigrationsResponse,
  WebsiteMigration,
  OrchestratorActionType,
  OrchestratorActionStatus,
} from '../../shared/models/website-migrations.models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebsiteMigrationsService {
  private http = inject(HttpClient);

  getAllMigrations(
    page: number,
    itemsPerPage: number,
    sourceWebsiteId?: number,
    targetWebsiteId?: number,
    type?: string,
    status?: string,
  ): Observable<WebsiteMigrationsResponse> {
    const query = new URLSearchParams();
    query.set('page', String(page));
    query.set('itemsPerPage', String(itemsPerPage));

    if (sourceWebsiteId) {
      query.set('sourceWebsiteId', String(sourceWebsiteId));
    }

    if (targetWebsiteId) {
      query.set('targetWebsiteId', String(targetWebsiteId));
    }

    if (type) {
      query.set('type', type);
    }

    if (status) {
      query.set('status', status);
    }

    return this.http.get<WebsiteMigrationsResponse>(`/websites/migrations?${query.toString()}`);
  }

  getMigration(id: number): Observable<WebsiteMigration> {
    return this.http.get<WebsiteMigration>(`/websites/migrations/${id}`);
  }

  renameWebsite({
    id,
    newDomain,
    excludeActions,
  }: {
    id: number;
    newDomain: string;
    excludeActions: string[];
  }): Observable<void> {
    return this.http.patch<void>(`/websites/${id}/rename`, { newDomain, excludeActions });
  }

  getMigrationsBySourceAndTargetGroups(
    sourceGroupId?: number,
    targetGroupId?: number,
  ): Observable<WebsiteMigration[]> {
    if ((!sourceGroupId || sourceGroupId === -1) && (!targetGroupId || targetGroupId === -1)) {
      throw new Error('No source and target groups found');
    }

    const query = new URLSearchParams();
    if (sourceGroupId && sourceGroupId !== -1) {
      query.set('sourceGroupId', String(sourceGroupId));
    }

    if (targetGroupId && targetGroupId !== -1) {
      query.set('targetGroupId', String(targetGroupId));
    }

    const id = !!targetGroupId && targetGroupId !== -1 ? targetGroupId : sourceGroupId;

    return this.http.get<WebsiteMigration[]>(
      `/websites/groups/${id}/migration?${query.toString()}`,
    );
  }

  updateMigrationActionStatus(
    migrationId: number,
    actionId: number,
    actionType: OrchestratorActionType,
    status: OrchestratorActionStatus,
  ): Observable<void> {
    return this.http.patch<void>(`/websites/migrations/${migrationId}/actions/${actionId}`, {
      actionType,
      status,
    });
  }
}
